import { render, staticRenderFns } from "./brand-count-table.vue?vue&type=template&id=5395824b"
import script from "./brand-count-table.vue?vue&type=script&lang=js"
export * from "./brand-count-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports